import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getUserStatusesAsPo } from '@api/users';

import { mapDropdownOptions } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { USERS_STATUSES_AS_PO } from '@constants/queryKeys';

interface IUseQueryUserStatusesAsPoReturned {
	userStatusOptions: Array<TSelectOption<string>>;
	isLoadingUserStatusOptions: boolean;
}

export const useQueryUserStatusesAsPo = (): IUseQueryUserStatusesAsPoReturned => {
	const {
		accessPermission: {
			platformOwnerAdministrator,
		},
	} = useAppSelector(auth);

	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [USERS_STATUSES_AS_PO],
		queryFn: getUserStatusesAsPo,
		select: (data) => mapDropdownOptions({
			items: data,
			valueKey: 'name',
			labelKey: 'title',
		}),
		enabled: [platformOwnerAdministrator],
		refetchOnWindowFocus: false,
	});

	return {
		userStatusOptions: data || [],
		isLoadingUserStatusOptions: isInitialLoading,
	};
};
